// extracted by mini-css-extract-plugin
export default {"loadingContainer":"page-loading-indicator_loadingContainer__C47xH"};